/*
 * All You Can Play - filtri delle collezioni: colonna a sinistra da computer (da 990 px), pannello "Filtra e ordina"
 * di Dawn da telefono e tablet.
 *
 * I prodotti sono già tutti nella pagina (sections/main-collection-product-grid.liquid, fino a 250 più quelli che
 * assets/collection-show-more.js carica in sottofondo), ognuno con prezzo, sconto, disponibilità, tag e set.
 * Questo script disegna i gruppi della colonna (snippets/collection-filters.liquid) con i numeri e, a ogni scelta,
 * nasconde i prodotti esclusi con la classe aycp-off, senza ricaricare la pagina.
 * - Tra gruppi diversi valgono tutte le scelte insieme, nello stesso gruppo basta una (es. Bundle o Booster Box).
 * - Il numero accanto a ogni voce è quanti prodotti si vedono scegliendola, con le altre scelte già fatte.
 * - Si vedono "Prodotti per pagina" prodotti alla volta; "Mostra di più" conta solo quelli filtrati.
 * - Un gruppo con una sola voce non si mostra (es. il gioco nella pagina di un gioco).
 * - Le scelte restano se si apre un prodotto e si torna indietro (sessionStorage, per indirizzo della pagina).
 * - Funziona anche dopo "Ordina per", che ridisegna la griglia.
 * - Vale anche nella pagina dei risultati della ricerca (sections/main-search.liquid), con i prodotti di Shopify o
 *   con quelli della ricerca italiana di riserva (assets/search-fallback.js); lì le scelte si tengono per parola cercata.
 * Telefono e tablet (sotto i 990 px): gli stessi gruppi, con le stesse scelte, vanno nel pannello "Filtra e ordina"
 * di Dawn, sotto "Ordina per", e tornano nella colonna da 990 px in su. Il pannello si apre solo toccandolo.
 * - Disponibilità e Prezzo di Dawn si nascondono (classe aycp-filters-in-drawer, stile in snippets/collection-filters.liquid).
 * - Le nostre caselle non fanno ricaricare il pannello a Dawn (input e change si fermano qui; i clic sui nostri
 *   pulsanti si gestiscono prima che il menu di Dawn li prenda per pulsanti di chiusura).
 * - In fondo al pannello "Applica" diventa "Mostra 21 prodotti"; "Rimuovi tutto" toglie le nostre scelte e, se ce
 *   ne sono, anche quelle di Dawn (le pillole sotto "Filtra e ordina").
 * - Il numero dei prodotti accanto a "Filtra e ordina" e nel pannello segue le scelte, come quello da computer.
 */
(function () {
  'use strict';

  var SETS_SHOWN = 8;
  var GROUPS = ['games', 'types', 'sets'];
  var STATES = ['avail', 'pre', 'sold'];
  var CHEVRON =
    '<svg viewBox="0 0 12 8" aria-hidden="true" focusable="false"><path d="M1 7l5-5 5 5" fill="none" stroke="currentColor" stroke-opacity=".55" stroke-width="1.6"/></svg>';

  function escapeHtml(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function addUnique(list, value) {
    if (value && list.indexOf(value) === -1) list.push(value);
  }

  function init(aside) {
    var dataElement = aside.querySelector('.aycp-filters__data');
    var data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    var strings = data.strings;
    var italian = (document.documentElement.lang || '').slice(0, 2) === 'it';
    var layout = aside.closest('.aycp-filters-layout');
    var groupsElement = aside.querySelector('.aycp-filters__groups');
    var resetButton = aside.querySelector('.aycp-filters__reset');
    var emptyElement = layout ? layout.querySelector('.aycp-filters__empty') : null;
    var desktop = window.matchMedia('(min-width: 990px)');
    // Nella ricerca le scelte valgono solo per le stesse parole cercate.
    var searchPage = /\/search\/?$/.test(window.location.pathname);
    var storageKey =
      'aycp-filters:' +
      window.location.pathname +
      (searchPage ? '?q=' + (new URLSearchParams(window.location.search).get('q') || '').trim().toLowerCase() : '');

    var products = [];
    var values = { games: [], types: [], sets: [] };
    var stateValues = [];
    var bounds = null;
    var hasSale = false;
    var applied = false;
    var closed = {};
    var setsOpen = false;
    var state = loadState();
    var priceTimer = null;
    var inDrawer = false;
    var drawerBox = null;

    function emptyState() {
      return { sale: false, min: null, max: null, state: [], games: [], types: [], sets: [] };
    }

    function loadState() {
      var saved = null;
      try {
        saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      } catch (error) {
        saved = null;
      }
      var fresh = emptyState();
      if (!saved || typeof saved !== 'object') return fresh;
      fresh.sale = saved.sale === true;
      fresh.min = typeof saved.min === 'number' ? saved.min : null;
      fresh.max = typeof saved.max === 'number' ? saved.max : null;
      ['state'].concat(GROUPS).forEach(function (key) {
        if (Array.isArray(saved[key])) fresh[key] = saved[key].filter(function (value) {
          return typeof value === 'string';
        });
      });
      return fresh;
    }

    function saveState() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) {
        /* sessionStorage non disponibile: le scelte valgono finché si resta nella pagina */
      }
    }

    function isActive() {
      return (
        state.sale ||
        state.min !== null ||
        state.max !== null ||
        state.state.length > 0 ||
        GROUPS.some(function (key) {
          return state[key].length > 0;
        })
      );
    }

    /* ---------- Prodotti ---------- */

    function setLabel(tag, tags) {
      var entry = null;
      for (var i = 0; i < tags.length && !entry; i++) {
        if (data.games[tags[i]] !== undefined) entry = data.sets[tags[i] + ':' + tag] || null;
      }
      entry = entry || data.sets[tag];
      if (!entry) return null;
      if (typeof entry === 'string') return entry;
      if (entry.unless && tags.indexOf(entry.unless) !== -1) return null;
      return (italian && entry.it) || entry.en || null;
    }

    function readProducts() {
      var list = document.getElementById('product-grid');
      if (!list || list.tagName !== 'UL') return [];
      var result = [];
      Array.prototype.forEach.call(list.children, function (item) {
        if (!item.hasAttribute('data-aycp-price')) return;
        var tags = (item.getAttribute('data-aycp-tags') || '').split('|').filter(Boolean);
        var product = {
          item: item,
          price: (parseInt(item.getAttribute('data-aycp-price'), 10) || 0) / 100,
          sale: item.getAttribute('data-aycp-sale') === '1',
          state: item.getAttribute('data-aycp-state') || 'avail',
          games: [],
          types: [],
          sets: [],
        };
        tags.forEach(function (tag) {
          if (data.games[tag]) addUnique(product.games, data.games[tag]);
          if (data.types[tag]) addUnique(product.types, data.types[tag]);
        });
        var setTitle = item.getAttribute('data-aycp-set');
        if (setTitle) {
          product.sets.push(setTitle);
        } else {
          tags.forEach(function (tag) {
            addUnique(product.sets, setLabel(tag, tags));
          });
        }
        result.push(product);
      });
      return result;
    }

    function collectValues() {
      values = { games: [], types: [], sets: [] };
      stateValues = [];
      hasSale = false;
      var min = Infinity;
      var max = -Infinity;
      products.forEach(function (product) {
        GROUPS.forEach(function (key) {
          product[key].forEach(function (value) {
            addUnique(values[key], value);
          });
        });
        addUnique(stateValues, product.state);
        if (product.sale) hasSale = true;
        if (product.price < min) min = product.price;
        if (product.price > max) max = product.price;
      });
      GROUPS.forEach(function (key) {
        values[key].sort(function (a, b) {
          return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
        });
      });
      bounds = products.length ? { min: Math.floor(min), max: Math.ceil(max) } : null;

      // Scelte salvate che in questa pagina non esistono più: si tolgono, altrimenti non si vedrebbe niente.
      GROUPS.forEach(function (key) {
        state[key] = state[key].filter(function (value) {
          return values[key].indexOf(value) !== -1;
        });
      });
      state.state = state.state.filter(function (value) {
        return stateValues.indexOf(value) !== -1;
      });
      if (!hasSale) state.sale = false;
      if (!bounds || bounds.min === bounds.max) {
        state.min = null;
        state.max = null;
      } else {
        if (state.min !== null && (state.min <= bounds.min || state.min > bounds.max)) state.min = null;
        if (state.max !== null && (state.max >= bounds.max || state.max < bounds.min)) state.max = null;
      }
    }

    function matches(product, skip) {
      if (skip !== 'sale' && state.sale && !product.sale) return false;
      if (skip !== 'price') {
        if (state.min !== null && product.price < state.min) return false;
        if (state.max !== null && product.price > state.max) return false;
      }
      if (skip !== 'state' && state.state.length && state.state.indexOf(product.state) === -1) return false;
      for (var i = 0; i < GROUPS.length; i++) {
        var key = GROUPS[i];
        if (skip === key || !state[key].length) continue;
        var found = false;
        for (var j = 0; j < product[key].length && !found; j++) {
          if (state[key].indexOf(product[key][j]) !== -1) found = true;
        }
        if (!found) return false;
      }
      return true;
    }

    function countFor(skip, test) {
      var count = 0;
      products.forEach(function (product) {
        if (test(product) && matches(product, skip)) count += 1;
      });
      return count;
    }

    /* ---------- Colonna ---------- */

    function money(value) {
      if (value >= 1000) {
        var thousands = (Math.round(value / 100) / 10).toString().replace('.', strings.decimal);
        return '€' + thousands + 'k';
      }
      return '€' + value;
    }

    function groupHtml(key, title, body) {
      var isClosed = closed[key] === true;
      return (
        '<div class="aycp-filters__group' + (isClosed ? ' is-closed' : '') + '" data-group="' + key + '">' +
        '<button type="button" class="aycp-filters__toggle" aria-expanded="' + (isClosed ? 'false' : 'true') + '">' +
        '<span>' + escapeHtml(title) + '</span>' + CHEVRON + '</button>' +
        '<div class="aycp-filters__body">' + body + '</div></div>'
      );
    }

    function optionHtml(key, value, label, extra) {
      return (
        '<label class="aycp-filters__option' + (extra ? ' is-extra' : '') + '">' +
        '<input type="checkbox" data-key="' + key + '" value="' + escapeHtml(value) + '">' +
        '<span>' + escapeHtml(label) + ' <span class="aycp-filters__count"></span></span></label>'
      );
    }

    function build() {
      var html = '';
      if (hasSale) html += groupHtml('sale', strings.sale, optionHtml('sale', '1', strings.saleOption, false));

      if (bounds && bounds.min < bounds.max) {
        var ticks = [0, 1, 2, 3, 4]
          .map(function (step) {
            return '<span>' + money(Math.round(bounds.min + ((bounds.max - bounds.min) * step) / 4)) + '</span>';
          })
          .join('');
        var range = ' min="' + bounds.min + '" max="' + bounds.max + '" step="1"';
        html += groupHtml(
          'price',
          strings.price,
          '<div class="aycp-filters__price-fields">' +
            '<input type="number" inputmode="numeric" class="aycp-filters__min" placeholder="' + escapeHtml(strings.min) + '" aria-label="' + escapeHtml(strings.minLabel) + '"' + range + '>' +
            '<span aria-hidden="true">–</span>' +
            '<input type="number" inputmode="numeric" class="aycp-filters__max" placeholder="' + escapeHtml(strings.max) + '" aria-label="' + escapeHtml(strings.maxLabel) + '"' + range + '>' +
            '</div>' +
            '<div class="aycp-filters__slider"><span class="aycp-filters__track"></span><span class="aycp-filters__fill"></span>' +
            '<input type="range" class="aycp-filters__range-min" aria-label="' + escapeHtml(strings.minLabel) + '"' + range + ' value="' + bounds.min + '">' +
            '<input type="range" class="aycp-filters__range-max" aria-label="' + escapeHtml(strings.maxLabel) + '"' + range + ' value="' + bounds.max + '">' +
            '</div>' +
            '<div class="aycp-filters__ticks">' + ticks + '</div>'
        );
      }

      if (stateValues.length > 1) {
        html += groupHtml(
          'state',
          strings.state,
          '<div class="aycp-filters__chips">' +
            STATES.filter(function (value) {
              return stateValues.indexOf(value) !== -1;
            })
              .map(function (value) {
                return (
                  '<button type="button" class="aycp-filters__chip" data-state="' + value + '" aria-pressed="false">' +
                  escapeHtml(strings[value]) + ' <span class="aycp-filters__count"></span></button>'
                );
              })
              .join('') +
            '</div>'
        );
      }

      GROUPS.forEach(function (key) {
        if (values[key].length < 2) return;
        var body = values[key]
          .map(function (value, index) {
            return optionHtml(key, value, value, key === 'sets' && index >= SETS_SHOWN);
          })
          .join('');
        if (key === 'sets' && values.sets.length > SETS_SHOWN) {
          body += '<button type="button" class="aycp-filters__more"></button>';
        }
        html += groupHtml(key, strings[key], body);
      });

      groupsElement.innerHTML = html;
      var setsBody = groupsElement.querySelector('[data-group="sets"] .aycp-filters__body');
      if (setsBody && setsOpen) setsBody.classList.add('is-open');
    }

    function updateMoreButton() {
      var button = groupsElement.querySelector('.aycp-filters__more');
      if (!button) return;
      button.textContent = setsOpen
        ? strings.less
        : strings.more.replace('[count]', values.sets.length - SETS_SHOWN);
    }

    function updatePriceControls() {
      if (!bounds || bounds.min >= bounds.max) return;
      var low = state.min !== null ? state.min : bounds.min;
      var high = state.max !== null ? state.max : bounds.max;
      var minField = groupsElement.querySelector('.aycp-filters__min');
      var maxField = groupsElement.querySelector('.aycp-filters__max');
      var minRange = groupsElement.querySelector('.aycp-filters__range-min');
      var maxRange = groupsElement.querySelector('.aycp-filters__range-max');
      var fill = groupsElement.querySelector('.aycp-filters__fill');
      if (!minField || !fill) return;
      if (document.activeElement !== minField) minField.value = state.min !== null ? state.min : '';
      if (document.activeElement !== maxField) maxField.value = state.max !== null ? state.max : '';
      minRange.value = low;
      maxRange.value = high;
      var span = bounds.max - bounds.min;
      fill.style.left = ((low - bounds.min) / span) * 100 + '%';
      fill.style.right = ((bounds.max - high) / span) * 100 + '%';
    }

    function updateCounts() {
      groupsElement.querySelectorAll('.aycp-filters__option input').forEach(function (input) {
        var key = input.getAttribute('data-key');
        var value = input.value;
        var count;
        var checked;
        if (key === 'sale') {
          checked = state.sale;
          count = countFor('sale', function (product) {
            return product.sale;
          });
        } else {
          checked = state[key].indexOf(value) !== -1;
          count = countFor(key, function (product) {
            return product[key].indexOf(value) !== -1;
          });
        }
        input.checked = checked;
        input.disabled = count === 0 && !checked;
        var option = input.closest('.aycp-filters__option');
        option.classList.toggle('is-empty', count === 0 && !checked);
        option.classList.toggle('is-checked', checked);
        option.querySelector('.aycp-filters__count').textContent = '(' + count + ')';
      });

      groupsElement.querySelectorAll('.aycp-filters__chip').forEach(function (chip) {
        var value = chip.getAttribute('data-state');
        var pressed = state.state.indexOf(value) !== -1;
        var count = countFor('state', function (product) {
          return product.state === value;
        });
        chip.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        chip.disabled = count === 0 && !pressed;
        chip.querySelector('.aycp-filters__count').textContent = '(' + count + ')';
      });

      updatePriceControls();
      updateMoreButton();
      resetButton.hidden = !isActive();
    }

    /* ---------- Griglia ---------- */

    function container() {
      return document.querySelector('[data-aycp-collection]');
    }

    // Mostra i primi "visible" prodotti rimasti e aggiorna "Mostra di più".
    function paginate(visible) {
      var wrapper = container();
      if (!wrapper) return;
      var shown = products.filter(function (product) {
        return !product.item.classList.contains('aycp-off');
      });
      shown.forEach(function (product, index) {
        product.item.hidden = index >= visible;
      });
      var button = wrapper.querySelector('.aycp-show-more');
      if (button) {
        var more = shown.some(function (product) {
          return product.item.hidden;
        });
        button.hidden = !more && wrapper.getAttribute('data-aycp-loading') !== 'true';
      }
    }

    function step() {
      var wrapper = container();
      return (wrapper && parseInt(wrapper.getAttribute('data-aycp-step'), 10)) || 16;
    }

    function visibleNow() {
      return products.filter(function (product) {
        return !product.item.classList.contains('aycp-off') && !product.item.hidden;
      }).length;
    }

    // Numero dei prodotti: da computer accanto a "Ordina per", da telefono e tablet accanto a "Filtra e ordina" e
    // nel pannello. Senza scelte resta il testo di Dawn; se Dawn lo riscrive (dopo "Ordina per" o un suo filtro)
    // il testo nuovo diventa quello da rimettere.
    function updateCount(count) {
      var filtered = isActive() && applied;
      var text = count === 1 ? strings.countOne : strings.countOther.replace(/[0-9]+/, count);
      var elements = [document.getElementById('ProductCountDesktop')];
      if (layout) elements.push(document.getElementById('ProductCount'), layout.querySelector('.mobile-facets__count'));
      var dawnText = '';
      elements.forEach(function (element, index) {
        if (!element) return;
        if (!element.hasAttribute('data-aycp-original') || element.textContent !== element.getAttribute('data-aycp-shown')) {
          element.setAttribute('data-aycp-original', element.textContent);
        }
        if (index === 1) dawnText = element.getAttribute('data-aycp-original');
        var shown = filtered ? text : element.getAttribute('data-aycp-original');
        if (element.textContent !== shown) element.textContent = shown;
        element.setAttribute('data-aycp-shown', shown);
      });
      updateShowButton(filtered ? count : parseInt((dawnText.match(/[0-9]+/) || [String(count)])[0], 10));
    }

    // "Applica" in fondo al pannello diventa "Mostra 21 prodotti" (chiude il pannello come prima).
    function updateShowButton(count) {
      var parts = drawerParts();
      var button = parts ? parts.footer.querySelector(':scope > .button') : null;
      if (!button) return;
      if (!button.hasAttribute('data-aycp-label')) button.setAttribute('data-aycp-label', button.textContent);
      var label = inDrawer
        ? (count === 1 ? strings.showOne : strings.showOther.replace('[count]', count))
        : button.getAttribute('data-aycp-label');
      if (button.textContent !== label) button.textContent = label;
    }

    /* ---------- Pannello "Filtra e ordina" da telefono e tablet ---------- */

    function drawerParts() {
      var main = layout ? layout.querySelector('#FacetsWrapperMobile') : null;
      var footer = main ? main.querySelector(':scope > .mobile-facets__footer') : null;
      return footer ? { main: main, footer: footer, form: main.closest('form') } : null;
    }

    // Sotto i 990 px i gruppi vanno nel pannello, sotto "Ordina per"; da 990 px tornano nella colonna.
    function place() {
      var parts = desktop.matches ? null : drawerParts();
      if (parts) {
        if (!drawerBox) {
          drawerBox = document.createElement('div');
          drawerBox.className = 'aycp-filters__drawer';
        }
        if (drawerBox.parentNode !== parts.main || drawerBox.nextElementSibling !== parts.footer) {
          parts.main.insertBefore(drawerBox, parts.footer);
        }
        if (groupsElement.parentNode !== drawerBox) drawerBox.appendChild(groupsElement);
        if (parts.form) parts.form.classList.add('aycp-filters-in-drawer');
        inDrawer = true;
        return;
      }
      if (groupsElement.parentNode !== aside) aside.insertBefore(groupsElement, dataElement);
      if (drawerBox && drawerBox.parentNode) drawerBox.parentNode.removeChild(drawerBox);
      var form = layout ? layout.querySelector('#FacetFiltersFormMobile') : null;
      if (form) form.classList.remove('aycp-filters-in-drawer');
      inDrawer = false;
    }

    function applyFilters(resetPages) {
      // da computer i filtri valgono solo se la colonna si vede (nelle collezioni dei set la nasconde
      // sections/aycp-altri-prodotti-gioco.liquid): scelte fatte nel pannello non restano attive senza colonna
      var columnShown = desktop.matches && aside.getClientRects().length > 0;
      var active = isActive() && (columnShown || inDrawer);
      var count = 0;
      products.forEach(function (product) {
        var keep = !active || matches(product, null);
        product.item.classList.toggle('aycp-off', !keep);
        if (keep) count += 1;
      });

      if (active || applied) {
        var visible = resetPages ? step() : Math.max(step(), visibleNow());
        paginate(active ? visible : resetPages ? step() : visible);
      }
      applied = active;

      if (emptyElement) {
        var none = active && count === 0;
        emptyElement.hidden = !none;
        if (none) {
          emptyElement.innerHTML =
            '<p>' + escapeHtml(strings.empty) + '</p><button type="button" class="aycp-filters__reset">' +
            escapeHtml(strings.reset) + '</button>';
        }
      }
      updateCount(count);
    }

    function refresh(resetPages) {
      updateCounts();
      applyFilters(resetPages);
      saveState();
    }

    // Prodotti nuovi o griglia ridisegnata (ordinamento, prodotti oltre il 250° caricati in sottofondo).
    function reload() {
      place();
      products = readProducts();
      collectValues();
      build();
      updateCounts();
      applyFilters(false);
    }

    /* ---------- Eventi ---------- */

    function resetAll() {
      state = emptyState();
      setsOpen = false;
      var setsBody = groupsElement.querySelector('[data-group="sets"] .aycp-filters__body');
      if (setsBody) setsBody.classList.remove('is-open');
      refresh(true);
    }

    groupsElement.addEventListener('change', function (event) {
      var target = event.target;
      if (target.matches('.aycp-filters__option input')) {
        var key = target.getAttribute('data-key');
        if (key === 'sale') {
          state.sale = target.checked;
        } else {
          var list = state[key];
          var position = list.indexOf(target.value);
          if (target.checked && position === -1) list.push(target.value);
          if (!target.checked && position !== -1) list.splice(position, 1);
        }
        refresh(true);
        return;
      }
      if (target.matches('.aycp-filters__min, .aycp-filters__max')) {
        var number = target.value === '' ? null : Math.round(parseFloat(target.value));
        if (number !== null && isNaN(number)) number = null;
        if (target.matches('.aycp-filters__min')) {
          if (number !== null) number = Math.min(Math.max(number, bounds.min), state.max !== null ? state.max : bounds.max);
          state.min = number === null || number <= bounds.min ? null : number;
        } else {
          if (number !== null) number = Math.max(Math.min(number, bounds.max), state.min !== null ? state.min : bounds.min);
          state.max = number === null || number >= bounds.max ? null : number;
        }
        target.blur();
        refresh(true);
      }
    });

    groupsElement.addEventListener('input', function (event) {
      var target = event.target;
      if (!target.matches('.aycp-filters__range-min, .aycp-filters__range-max')) return;
      var minRange = groupsElement.querySelector('.aycp-filters__range-min');
      var maxRange = groupsElement.querySelector('.aycp-filters__range-max');
      var low = parseInt(minRange.value, 10);
      var high = parseInt(maxRange.value, 10);
      if (low > high) {
        if (target === minRange) low = high;
        else high = low;
      }
      state.min = low <= bounds.min ? null : low;
      state.max = high >= bounds.max ? null : high;
      updatePriceControls();
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        refresh(true);
      }, 150);
    });

    groupsElement.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.matches('.aycp-filters__min, .aycp-filters__max')) {
        event.preventDefault();
        event.target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    function onClick(event) {
      var toggle = event.target.closest('.aycp-filters__toggle');
      if (toggle) {
        var group = toggle.closest('.aycp-filters__group');
        var key = group.getAttribute('data-group');
        closed[key] = !group.classList.contains('is-closed');
        group.classList.toggle('is-closed', closed[key]);
        toggle.setAttribute('aria-expanded', closed[key] ? 'false' : 'true');
        return;
      }
      var chip = event.target.closest('.aycp-filters__chip');
      if (chip) {
        var value = chip.getAttribute('data-state');
        var position = state.state.indexOf(value);
        if (position === -1) state.state.push(value);
        else state.state.splice(position, 1);
        refresh(true);
        return;
      }
      var more = event.target.closest('.aycp-filters__more');
      if (more) {
        setsOpen = !setsOpen;
        more.closest('.aycp-filters__body').classList.toggle('is-open', setsOpen);
        updateMoreButton();
      }
    }

    groupsElement.addEventListener('click', onClick);

    // Nel pannello Dawn tratta ogni pulsante come "chiudi" (menu-drawer, bindEvents dopo "Ordina per"):
    // i clic sui nostri pulsanti si gestiscono qui, prima che arrivino al pulsante.
    groupsElement.addEventListener(
      'click',
      function (event) {
        if (!inDrawer || !event.target.closest('button')) return;
        event.stopPropagation();
        onClick(event);
      },
      true
    );

    // Nel pannello le nostre caselle non devono far ricaricare la pagina a Dawn (che ascolta "input" sul suo form).
    ['input', 'change'].forEach(function (type) {
      groupsElement.addEventListener(type, function (event) {
        if (inDrawer) event.stopPropagation();
      });
    });

    // "Rimuovi tutto" in fondo al pannello: toglie le nostre scelte; se non ci sono filtri di Dawn attivi
    // (le pillole sotto "Filtra e ordina"), Dawn non ricarica niente.
    if (layout) {
      layout.addEventListener(
        'click',
        function (event) {
          if (!inDrawer || !event.target.closest('#FacetsWrapperMobile > .mobile-facets__footer .mobile-facets__clear')) return;
          var dawnFilters = layout.querySelector('.active-facets-mobile > facet-remove:not(.active-facets__button-wrapper)');
          resetAll();
          if (!dawnFilters) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );
    }

    resetButton.addEventListener('click', resetAll);
    if (emptyElement) {
      emptyElement.addEventListener('click', function (event) {
        if (event.target.closest('.aycp-filters__reset')) resetAll();
      });
    }

    var media = function () {
      place();
      applyFilters(true);
    };
    if (desktop.addEventListener) desktop.addEventListener('change', media);
    else if (desktop.addListener) desktop.addListener(media);

    var timer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(reload, 50);
    });
    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) observer.observe(gridContainer, { childList: true, subtree: true });

    // Dopo "Ordina per" Dawn ridisegna anche il numero dei prodotti in alto (collezioni e ricerca).
    var facets = document.getElementById('main-collection-filters') || document.getElementById('main-search-filters');
    if (facets) {
      new MutationObserver(function () {
        updateCount(
          products.filter(function (product) {
            return !product.item.classList.contains('aycp-off');
          }).length
        );
      }).observe(facets, { childList: true, subtree: true, characterData: true });
    }

    products = readProducts();
    collectValues();
    build();
    place();
    updateCounts();
    applyFilters(true);
  }

  function start() {
    var aside = document.getElementById('AycpFilters');
    if (aside && !aside.hasAttribute('data-ready')) {
      aside.setAttribute('data-ready', 'true');
      init(aside);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
